enum ActionTypes {
  GET_ALL_SPORTS_RO_CALCULATOR = '@sportsRO/GET_ALL_SPORTS_RO_CALCULATOR',
}

export default ActionTypes
